import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faBullseyePointer,
  faCalendar as faCalendarRegular,
  faCalendarDay,
  faCircle as faCircleRegular,
  faCircleCheck as faCircleCheckRegular,
  faEllipsisVertical,
  faEllipsis,
  faHelmetSafety,
  faMedal,
  faUsersCog,
  faFileCertificate,
  faSquare,
  faSearch,
  faSunglasses,
  faCircleDot,
  faClock,
  faCommentDots as faCommentDotsRegular,
  faSquarePollVertical,
  faStar,
  faTrophy,
  faAward as faAwardRegular,
  faGridDividers,
  faSquareCheck as faSquareCheckRegular,
  faFileWord,
  faPenRuler,
  faMessage,
  faArrowsToDot,
  faHandWave
} from '@fortawesome/pro-regular-svg-icons'
import {
  faRobot,
  fa0,
  fa1,
  fa2,
  fa3,
  fa4,
  fa5,
  fa6,
  fa7,
  fa8,
  fa9,
  faAngleLeft,
  faBars,
  faBarsFilter,
  faBell,
  faBooks,
  faBookSpells,
  faCauldron,
  faCircleCheck as faCircleCheckSolid,
  faCog,
  faCommentAltCheck,
  faCommentEdit,
  faCommentDots,
  faComments,
  faCircleUp,
  faCircleStar,
  faDiceD6,
  faDiceD10,
  faExclamationTriangle,
  faExpandAlt,
  faExpandArrowsAlt,
  faExternalLinkAlt,
  faEye,
  faEmptySet,
  faFileCsv,
  faFileXml,
  faFileImport,
  faFileExport,
  faImages,
  faLanguage,
  faLayerGroup,
  faListCheck,
  faMoneyCheckEdit,
  faProjectDiagram,
  faPalette,
  faSignOutAlt,
  faSlidersH,
  faSpellCheck,
  faSquareCheck,
  faThList,
  faTrianglePersonDigging,
  faToggleOn,
  faUser,
  faUserTie,
  faUserPlus,
  faUsersClass,
  faWifiSlash,
  faBoxArchive,
  faGlobe as faGlobeSolid,
  faPlus,
  faMinus,
  faGripLines,
  faCircleMinus,
  faPencilMechanical,
  faXmark,
  faCircleXmark,
  faStarHalfStroke,
  faSortUp,
  faSortDown,
  faPaperPlaneTop,
  faArrowDownToLine,
  faCircleSmall,
  faCloudArrowDown,
  faCloudArrowUp,
  faChildReaching,
  faPerson,
  faPersonRunningFast,
  faPersonRunning,
  faPersonWalking,
  faShoePrints,
  faUsersRays,
  faUserMagnifyingGlass,
  faGripDotsVertical,
  faCircleInfo,
  faSquareList,
  faSparkles,
  faPercent,
  faAward as faAwardSolid
} from '@fortawesome/pro-solid-svg-icons'
import {
  faAtlas,
  faAppleAlt,
  faAtom,
  faAward,
  faAbacus,
  faBallPile,
  faBacterium,
  faBacteria,
  faBaby,
  faBackpack,
  faBalanceScale,
  faBalanceScaleLeft,
  faBalanceScaleRight,
  faBaseballBall,
  faBaseball,
  faBallot,
  faBallotCheck,
  faBringForward,
  faBringFront,
  faBong,
  faBezierCurve,
  faBells,
  faBellSchool,
  faBrain,
  faBoxAlt,
  faBoxBallot,
  faBoxCheck,
  faBox,
  faBooks as faBooksLigth,
  faBoxes,
  faBookAlt,
  faBurn,
  faBrush,
  faBusinessTime,
  faCabinetFiling,
  faCalendar,
  faCalculatorAlt,
  faChalkboardTeacher,
  faCheck,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleExclamation,
  faCoin,
  faCoins,
  faClipboardCheck,
  faClipboardListCheck,
  faClipboardList,
  faBookOpen,
  faCapsules,
  faCampfire,
  faComment,
  faCropAlt,
  faDice,
  faDiploma,
  faDonate,
  faDewpoint,
  faDebug,
  faExclamationTriangle as faExclamationTriangleLight,
  faHandshakeAlt,
  faHeadSideBrain,
  faFan,
  faFileCertificate as faFileCertificateLight,
  faFunction,
  faGlobe,
  faGlobeAmericas,
  faGalaxy,
  faGhost,
  faLanguage as faLanguageLight,
  faLandmarkAlt,
  faLightbulbExclamation,
  faLightbulbOn,
  faListAlt,
  faMask,
  faMinusSquare,
  faMoneyCheckEdit as faMoneyCheckEditLight,
  faMusic,
  faNewspaper,
  faObjectGroup,
  faPalette as faPaletteLight,
  faPi,
  faPaperclip,
  faPencil,
  faPencilPaintbrush,
  faPhoneLaptop,
  faPhotoVideo,
  faOmega,
  faRunning,
  faScrollOld,
  faSquareRootAlt,
  faShapes,
  faSchool,
  faTasks,
  faTimes,
  faTimesSquare,
  faTheaterMasks,
  faUserSecret,
  faUserFriends,
  faWifi,
  faWifiSlash as faWifiSlashLight,
  faCopy,
  faRectangleList,
  faFileSpreadsheet,
  faFilePowerpoint,
  faChartColumn,
  faCircleInfo as faCircleInfoLight
} from '@fortawesome/pro-light-svg-icons'

library.add(
  faCircleInfoLight,
  faRobot,
  fa0,
  fa1,
  fa2,
  fa3,
  fa4,
  fa5,
  fa6,
  fa7,
  fa8,
  fa9,
  faAbacus,
  faAppleAlt,
  faAngleLeft,
  faAtlas,
  faAtom,
  faAward,
  faArrowsToDot,
  faBrush,
  faBrain,
  faBoxes,
  faBong,
  faBallPile,
  faBacterium,
  faBacteria,
  faBackpack,
  faBaby,
  faBalanceScale,
  faBalanceScaleLeft,
  faBalanceScaleRight,
  faBaseballBall,
  faBaseball,
  faBallot,
  faBallotCheck,
  faBars,
  faBarsFilter,
  faBell,
  faBullseyePointer,
  faBezierCurve,
  faBells,
  faBellSchool,
  faBookAlt,
  faBoxAlt,
  faBoxBallot,
  faBoxCheck,
  faBox,
  faBooksLigth,
  faBooks,
  faBookSpells,
  faBurn,
  faBringForward,
  faBringFront,
  faBusinessTime,
  faCabinetFiling,
  faCalendar,
  faCalculatorAlt,
  faCalendarDay,
  faCalendarRegular,
  faCauldron,
  faChalkboardTeacher,
  faCheck,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faFunction,
  faCircle,
  faCircleUp,
  faCircleStar,
  faCircleSmall,
  faCircleCheckRegular,
  faCircleCheckSolid,
  faCircleExclamation,
  faCircleRegular,
  faCog,
  faComment,
  faCommentAltCheck,
  faCommentEdit,
  faCommentDots,
  faComments,
  faCoin,
  faCoins,
  faCapsules,
  faCampfire,
  faClipboardCheck,
  faClipboardListCheck,
  faClipboardList,
  faBookOpen,
  faCropAlt,
  faDiceD6,
  faDiceD10,
  faDice,
  faDonate,
  faDiploma,
  faDewpoint,
  faDebug,
  faArrowDownToLine,
  faCloudArrowDown,
  faCloudArrowUp,
  faEllipsisVertical,
  faEllipsis,
  faExclamationTriangle,
  faExclamationTriangleLight,
  faExpandAlt,
  faExpandArrowsAlt,
  faExternalLinkAlt,
  faEye,
  faEmptySet,
  faFan,
  faFileCertificate,
  faFileCertificateLight,
  faFileCsv,
  faFileXml,
  faFileExport,
  faFileImport,
  faHandshakeAlt,
  faHeadSideBrain,
  faHandWave,
  faHelmetSafety,
  faImages,
  faGlobe,
  faGalaxy,
  faGhost,
  faGlobeAmericas,
  faLandmarkAlt,
  faLanguage,
  faLanguageLight,
  faLayerGroup,
  faLightbulbExclamation,
  faLightbulbOn,
  faListAlt,
  faListCheck,
  faMask,
  faMedal,
  faMessage,
  faMinusSquare,
  faMoneyCheckEdit,
  faMoneyCheckEditLight,
  faMusic,
  faNewspaper,
  faObjectGroup,
  faPalette,
  faPaletteLight,
  faPaperclip,
  faPaperPlaneTop,
  faPi,
  faPencil,
  faPencilPaintbrush,
  faPenRuler,
  faPerson,
  faPersonRunningFast,
  faPersonRunning,
  faPersonWalking,
  faPhoneLaptop,
  faPhotoVideo,
  faProjectDiagram,
  faOmega,
  faRunning,
  faScrollOld,
  faSearch,
  faSquareRootAlt,
  faSignOutAlt,
  faShapes,
  faSchool,
  faSlidersH,
  faSpellCheck,
  faShoePrints,
  faSquare,
  faSquareCheck,
  faSunglasses,
  faTheaterMasks,
  faTasks,
  faTimes,
  faTimesSquare,
  faThList,
  faToggleOn,
  faTrianglePersonDigging,
  faUser,
  faUserTie,
  faUserPlus,
  faUsersClass,
  faUserFriends,
  faUsersCog,
  faUserSecret,
  faWifiSlash,
  faWifi,
  faWifiSlashLight,
  faCircleDot,
  faClock,
  faCommentDotsRegular,
  faSquarePollVertical,
  faStar,
  faTrophy,
  faAwardRegular,
  faGridDividers,
  faBoxArchive,
  faGlobeSolid,
  faPlus,
  faMinus,
  faGripLines,
  faCircleMinus,
  faPencilMechanical,
  faXmark,
  faCircleXmark,
  faStarHalfStroke,
  faCopy,
  faRectangleList,
  faSquareCheckRegular,
  faSortUp,
  faSortDown,
  faFileWord,
  faFileSpreadsheet,
  faFilePowerpoint,
  faChildReaching,
  faUsersRays,
  faUserMagnifyingGlass,
  faGripDotsVertical,
  faCircleInfo,
  faSquareList,
  faChartColumn,
  faSparkles,
  faPercent,
  faAwardSolid
)
